import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Popover, Tag } from 'antd';
import UnitOfMeasureType from "../../enums/UnitOfMeasureType";
import { roundToPrecision } from "../../../../swzutils";
import { freightDescription } from "../../../../util/FormatUtil";
const ConsignmentFreightPopover = ({ consignment, forcePopover }) => {
    if (!consignment.freight || !consignment.freight.length) {
        return null;
    }
    if (consignment.freight.length === 1 && !forcePopover) {
        const f = consignment.freight[0];
        const uom = f.netUnitOfMeasure || f.unitOfMeasure;
        const qty = f.cubicToTonneConvertedQty ? f.orderedQuantity : (f.netQuantity || f.orderedQuantity);
        const description = freightDescription(f);
        return (_jsxs("span", { children: [description, " - ", qty, " ", UnitOfMeasureType.valueOf(uom).description] }));
    }
    let total = 0;
    const freightRows = consignment.freight.map(f => {
        const uom = f.netUnitOfMeasure || f.unitOfMeasure;
        const qty = f.cubicToTonneConvertedQty ? f.orderedQuantity : (f.netQuantity || f.orderedQuantity);
        total += qty;
        const description = freightDescription(f);
        return (_jsxs("tr", { children: [_jsx("td", { children: description }), _jsx("td", { children: UnitOfMeasureType.valueOf(uom).description }), _jsx("td", { style: { textAlign: "right" }, children: qty })] }, "freightId" + f.id));
    });
    return (_jsx(Popover, { destroyOnHidden: true, content: _jsx("table", { className: "table-popover", children: _jsx("tbody", { children: freightRows }) }), title: "Freight", children: _jsx(Tag, { children: roundToPrecision(total, 2) }) }));
};
export default ConsignmentFreightPopover;
